import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { AppService } from 'src/app/shared/services/app.service';
import { AdminService } from 'src/app/admin/services/admin.service';

import { Router, ActivatedRoute } from '@angular/router';
import { Role } from 'src/app/shared/interfaces/interfaces';
import { Subscription, timer } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators'; 
import { Subject } from 'rxjs'; 
declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  role: string[];
  badgeVar?: string;
}

export const ROUTES: RouteInfo[] = [
  // { path: 'heatmap', title: 'Επισκόπηση', icon: 'insert_chart', role: ["cityAdmin"] },
  { path: 'certified_clubs', title: 'CERTIFIED_CLUBS', icon: 'accessible', role: ["cityAdmin"] },
  { path: 'certified_services', title: 'CERTIFIED_SERVICES', icon: 'business', role: ["cityAdmin"] },

  { path: 'certification/clubs', title: 'APPLICATIONS_CLUBS', icon: 'list_alt', role: ["cityAdmin"], badgeVar: 'clubApplications' },
  { path: 'certification/operations', title: 'APPLICATIONS_OPERATIONS', icon: 'list_alt', role: ["cityAdmin"], badgeVar: 'serviceApplications' },
  { path: 'users_overview', title: 'USERS_OVERVIEW', icon: 'people', role: ["registration_manager"], badgeVar: 'usersApplications' },
  { path: 'pending_users', title: 'PENDING_USERS', icon: 'pending_actions', role: ["registration_manager"], badgeVar: 'pendingUsers' },
  { path: 'user_add', title: 'USER_ADD', icon: 'person_add', role: ["registration_manager"] },
  { path: 'service_overview', title: 'SERVICE_OVERVIEW', icon: 'location_searching', role: ["operator"] },

  // USER MINISTRY
  { path: 'ministry_overview', title: 'Επισκόπηση', icon: 'business', role: ["ministry"] },
  { path: 'municipalities', title: 'Δήμοι', icon: 'location_city', role: ['ministry'] },
];

const payload: any = {
  sort: 1,
  page: 1,
  limit: 100,
  activity_problem: [0, 1],
  disabilities: [],
  lowest_age: 0,
  highest_age: 140,
  statuses: ["pending"]
};

export interface RoleWithSidenavItems extends Role {
  menuItems?: any
  roleName?: string
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [AdminService]
})
export class DashboardComponent implements OnInit, OnDestroy {

  lgScreenQuery: MediaQueryList
  mdScreenQuery: MediaQueryList
  private _mobileQueryListener: () => void

  
  private destroy$ = new Subject<void>();

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private appService: AppService,
    public adminService: AdminService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.lgScreenQuery = media.matchMedia('(max-width: 1200px)')
    this.mdScreenQuery = media.matchMedia('(max-width: 992px)')
    this._mobileQueryListener = () => { changeDetectorRef.detectChanges() }
    this.lgScreenQuery.addListener(this._mobileQueryListener)
    this.mdScreenQuery.addListener(this._mobileQueryListener)
  }

  menuItems: any[];
  username: string
  roles: RoleWithSidenavItems[]

  subscription$ = new Subscription()

  ngOnInit() {
    console.log("000000000000000000");

    this.username = this.appService.loggedUser.email
    this.roles = this.appService.loggedUser.roles
    console.log("this.roles_______________________________________________________________");
    console.log(this.roles);

    this.roles.forEach(role => {
      role['menuItems'] = ROUTES.filter(menuItem => menuItem.role.includes(role.value))

      if (this.appService.loggedUser.info.find(item => item.name === role.value)) {
        role['roleName'] = this.appService.loggedUser.info.find(item => item.name === role.value).obj.name;
      }

      console.log("123");
      console.log(
        this.appService.loggedUser.info.find(item => item.name === role.value)
      )
      console.log("role['roleName']______________");
      console.log(role['roleName']);
    })

    if (this.activatedRoute.children.length === 0) {
      this.router.navigate(['admin', this.roles[0]['menuItems'][0].path])
    }

    
    if (this.roles.some(role => role.value === "cityAdmin")) {
      console.log("city admin queries_________________");
      this.cityAdminQueries();
    }

   
    if (this.roles.some(role => role.value === "registration_manager")) {
      this.RegistrationManagerQueries()

      this.subscription$.add(
        this.adminService.userChanged$
          .pipe(
            debounceTime(500), 
            distinctUntilChanged(), 
            takeUntil(this.destroy$) 
          )
          .subscribe(data => {
            if (data) {
              console.log('User changed signal received, fetching latest data...');
              this.RegistrationManagerQueries()
            }
          })
      )
    }
  }

  
  cityAdminQueries() {
    this.appService.fetch_sectors({ status: 'pending', operations: true, clubs: true })
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          console.log("City admin data received");
          console.log(data);

          if (data.clubs && data.clubs.length) {
            this.adminService.clubApplications = data.clubs.length
          }
          if (data.operators && data.operators.length) {
            this.adminService.serviceApplications = data.operators.length
          }
        },
        error => {
          console.error('Error fetching city admin data:', error);
        }
      )
  }

  
  RegistrationManagerQueries() {
    console.log('RegistrationManagerQueries CALLED');

    this.appService.fetch_manager_users_with_filters(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        response => {
          const data = response.data;
          console.log("Response received, total users:", data.length);

          const pendingApplications = data.filter(user => user.status === 'pending');
          console.log("Pending count:", pendingApplications.length);

          // Αποθηκεύει τον αριθμό (0 αν δεν υπάρχουν)
          if (pendingApplications.length) {
            this.adminService.usersApplications = pendingApplications.length;
            console.log("SET usersApplications to:", this.adminService.usersApplications);
          } else {
            this.adminService.usersApplications = 0;
            console.log("SET usersApplications to 0");
          }
        },
        error => {
          console.error('Error fetching users:', error);
          
        }
      )
  }

  logout() {
    this.appService.logout()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        data => {
          console.log('Logout successful');
        },
        error => {
          console.error('Logout error:', error);
        }
      )
    this.router.navigate(['admin', 'login'])
  }

  myAccount() {
    this.router.navigateByUrl('/admin/my_account');
  }

  
  ngOnDestroy() {
    console.log('DashboardComponent destroyed - cleaning up subscriptions');

    
    this.lgScreenQuery.removeListener(this._mobileQueryListener)
    this.mdScreenQuery.removeListener(this._mobileQueryListener)

    
    this.destroy$.next();
    this.destroy$.complete();
    this.subscription$.unsubscribe()
  }
}